import { Box, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { MissedBadgeCounter } from "./MissedBadgeCounter";

interface MissedBadgeCounterContainerProps {
  unverifiedBadgeCount?: number;
  hasWorkedBadgeRequiredShift: boolean;
}

export function MissedBadgeCounterContainer(props: MissedBadgeCounterContainerProps) {
  const { unverifiedBadgeCount = 0, hasWorkedBadgeRequiredShift } = props;

  return (
    <Box>
      {unverifiedBadgeCount === 0 && hasWorkedBadgeRequiredShift && (
        <Box
          sx={(theme) => ({
            background: theme.palette.shift?.badgePolicy.successGradient,
            paddingY: theme.spacing(7),
            borderTopLeftRadius: theme.borderRadius?.medium,
            borderTopRightRadius: theme.borderRadius?.medium,
            display: "flex",
            justifyContent: "center",
            marginBottom: theme.spacing(-5),
            zIndex: 11,
            position: "relative",
            overflow: "visible",
          })}
        >
          <Text bold variant="body2">
            Thank you for being prepared!
          </Text>
        </Box>
      )}
      <Stack
        alignItems="center"
        spacing={6}
        sx={(theme) => ({
          backgroundColor: theme.palette.background.tertiary,
          padding: theme.spacing(5),
          zIndex: 10,
          position: "relative",
          borderRadius: theme.borderRadius?.medium,
          ...(unverifiedBadgeCount === 0 &&
            hasWorkedBadgeRequiredShift && {
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
            }),
          border: `${theme.borderWidth.regular} solid #F9E1E1`,
          boxShadow: 3,
        })}
      >
        <MissedBadgeCounter unverifiedBadgeCount={unverifiedBadgeCount} />
      </Stack>
    </Box>
  );
}
